__webpack_require__.p = "/reports-legacy-deprecation-banner/referrals-hub/";